import React, { useEffect, useState } from 'react';
import { ButtonWrapper, SmallTabButton } from '../../../styles/button.style';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import mapTankCleaningUtils from '../../../utils/mapTankCleaningUtils';
import { RoleTypeEnum } from '../../../enums/roleTypeEnum';
import { useAuthStore } from '../../../context/AuthContext';
import { ChemicalOrderStatusEnum } from '../../../enums/chemicalOrderStatusEnum';
import { ChemicalOrderPortCall } from '../../../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';

const NewButtonManagerForOrderComponent: React.FC = () => {
    const [filteredChemicalOrderForPortCallList, setFilteredChemicalOrderForPortCallList] = useState<ChemicalOrderPortCall[]>([]);
    const { isNewOrder, setIsNewOrder, selectedChemicalOrderForPortCallList, chemicalOrderUpdateReportData } = useTankCleaningStore();
    const { getMainChemicalOrders } = mapTankCleaningUtils();
    const { role } = useAuthStore();

    // ========== USE EFFECTS ===========

    useEffect(() => {
        const _filteredChemicalOrderForPortCallList = getMainChemicalOrders(selectedChemicalOrderForPortCallList);
        setFilteredChemicalOrderForPortCallList([..._filteredChemicalOrderForPortCallList]);
    }, [selectedChemicalOrderForPortCallList]);

    const onNewChemicalOrder = () => {
        setIsNewOrder(true);
    };

    const isDisabledButton = () => {
        if (
            (role.roleType === RoleTypeEnum.ShipUser || role.roleType === RoleTypeEnum.ShipOperator || role.roleType === RoleTypeEnum.Admin) &&
            !isNewOrder &&
            chemicalOrderUpdateReportData &&
            chemicalOrderUpdateReportData.chemicalOrderItemList.length > 0 &&
            filteredChemicalOrderForPortCallList &&
            filteredChemicalOrderForPortCallList.length > 0 &&
            filteredChemicalOrderForPortCallList[0]?.lastOrderStatusId !== ChemicalOrderStatusEnum.Unsaved &&
            filteredChemicalOrderForPortCallList[0]?.lastOrderStatusId !== ChemicalOrderStatusEnum.Draft
        ) {
            return false;
        }
        return true;
    };

    return (
        <ButtonWrapper>
            {role && (
                <SmallTabButton
                    title="New order"
                    className="add-order"
                    key={`tab_menu_chemical_order_0_0_0`}
                    isSelected={isNewOrder}
                    onClick={() => onNewChemicalOrder()}
                    disabled={isDisabledButton()}
                >
                    <span>+</span>
                </SmallTabButton>
            )}
        </ButtonWrapper>
    );
};

export default NewButtonManagerForOrderComponent;
